import { useMembersContext } from '@/contexts/membersContext';
import { Me } from '@/pages/members/types';
import ajax from '@/utils/ajax';

export const userRepository = {
  async me({ host }: { host: string }): Promise<Me> {
    const path = `/api/members/me`;
    const response = await ajax.get({
      url: `${host}${path}`,
      config: {
        withCredentials: true
      }
    });

    return response.data;
  }
};

const UserRepository = () => {
  const { host } = useMembersContext();

  return {
    async me(): Promise<Me> {
      return userRepository.me({ host });
    }
  };
};

export default UserRepository;
